import { render, staticRenderFns } from "./Monitor2.vue?vue&type=template&id=66e907ad&"
import script from "./Monitor2.vue?vue&type=script&lang=js&"
export * from "./Monitor2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports